import { IPriceDetails } from '@/@types'

const state: IPriceDetails = {
  currencySymbol: '$',
  currencyCode: 'USD',
  discount: 0,
  discountStr: '',
  showPromotionSavings: false,
  subtotal: 0,
  subtotalStr: '',
  taxes: 0,
  taxesStr: '',
  total: 0,
  totalStr: '',
}

export default state
